import React, { useEffect } from 'react';

import ContentWrapper from 'components/ContentWrapper';
import CommissionReportHeader from 'components/tables/CommissionReportTable/Header';
import CommissionReportTable from 'components/tables/CommissionReportTable';
import { updateTitle } from 'helpers/common';

const wrapperStyle = {
  padding: '20px 40px 16px 40px',
  display: 'grid',
  gridTemplateColumns: '100%',
  gridTemplateRows: 'auto calc(100% - 108px)',
  height: '100%',
  backgroundColor: '#F7F8FA',
};
const InterestsReportScreen: any = ({ ...props }) => {
  const { requestParams } = props;

  useEffect(() => {
    updateTitle('Commission Report');
  }, []);

  return (
    <ContentWrapper style={wrapperStyle}>
      <CommissionReportHeader requestParams={requestParams} />
      <CommissionReportTable requestParams={requestParams} />
    </ContentWrapper>
  );
};

export default InterestsReportScreen;
